import React, {Component} from 'react';
import {Spinner} from 'reactstrap';

export class MainButton extends Component {
    render() {
        if (this.props.loading) {
            return <Spinner className="spinner-color"/>;
        } else {
            return (
                <button
                    className={`${this.props.styleName}-button ${this.props.className || ''}`}
                    onClick={this.props.onClick}
                    disabled={this.props.disabled || false}
                >
                    {this.props.text}
                </button>
            )
        }
    }
}
